export default __webpack_public_path__ + "static/media/pushplay.8facdf07.ico";